import { render } from "./HolidaysList.vue?vue&type=template&id=5db76706&scoped=true"
import script from "./HolidaysList.vue?vue&type=script&lang=js"
export * from "./HolidaysList.vue?vue&type=script&lang=js"

import "./HolidaysList.vue?vue&type=style&index=0&id=5db76706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db76706"]])

export default __exports__